// extracted by mini-css-extract-plugin
module.exports = {"audioBlock":"style_audioBlock__2tWwG","embed":"style_embed__x4EDM","providerLinks":"style_providerLinks__01Rci"};